export default __webpack_public_path__ + "static/media/emails.8c40d868.png";